var React = require('react');

function Arrow2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.5 8.50427C9.6875 8.31677 9.82812 8.03552 9.82812 7.7074C9.82812 7.42615 9.6875 7.1449 9.5 6.91052L3.125 0.535522C2.89062 0.348022 2.60938 0.207397 2.32812 0.207397C2 0.207397 1.71875 0.348022 1.53125 0.535522L0.5 1.61365C0.265625 1.84802 0.171875 2.12927 0.171875 2.41052C0.171875 2.73865 0.265625 3.0199 0.5 3.2074L5 7.7074L0.5 12.2074C0.265625 12.4418 0.171875 12.723 0.171875 13.0043C0.171875 13.3324 0.265625 13.6136 0.5 13.8011L1.53125 14.8793C1.71875 15.1136 2 15.2074 2.32812 15.2074C2.60938 15.2074 2.89062 15.1136 3.125 14.8793L9.5 8.50427Z","fill":"white"}));
}

Arrow2.defaultProps = {"width":"10","height":"16","viewBox":"0 0 10 16","fill":"none"};

module.exports = Arrow2;

Arrow2.default = Arrow2;
